import { useEffect, useRef } from 'react';

export function useDebouncedCallback<T extends any[]>(callback: (...args: T) => void, delay: number = 100) {
    const argsRef = useRef<T>(undefined);
    const timeout = useRef<ReturnType<typeof setTimeout>>(undefined);

    function cleanup() {
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
    }

    useEffect(() => cleanup, []);

    return function debouncedCallback(...args: T) {
        argsRef.current = args;

        cleanup();

        timeout.current = setTimeout(() => {
            if (argsRef.current) {
                callback(...argsRef.current);
            }
        }, delay);
    };
}
